/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "@mui/styled-engine-sc";
import ListItemAvatar from "@mui/material/ListItemAvatar";

const StyledListItemAvatar = styled(({ ...props }) => <ListItemAvatar {...props} />)`
  && {
  }
`;

export { StyledListItemAvatar };
